"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderCarousel = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
function SliderCarousel({ children, slider, visibleTabCount = 1, slideGroup = 2, totalElements, sliderElementRef, singleelement }) {
    const tabs = react_1.default.Children.toArray(children);
    const totalTabCount = totalElements || tabs.length;
    const { springs, bindGestureHandlers } = slider;
    // Calculate slice according with carousel specs
    const getSlideTransformStyle = (x) => {
        if (visibleTabCount > 1) {
            return `translate3d(${x * -slideGroup}px,0,0)`;
        }
        return `translate3d(${x * -1}px,0,0)`;
    };
    return (react_1.default.createElement(styled_1.StyledSliderCarouselWrapper, { className: "slider-carousel-wrapper" },
        react_1.default.createElement(styled_1.StyledSliderContainer, { ref: sliderElementRef, totalColumnCount: totalTabCount, visibleColumnCount: visibleTabCount, className: "slider-container" }, springs.map(({ x }, index) => (react_1.default.createElement(styled_1.StyledChildWrapper, Object.assign({}, bindGestureHandlers(), { key: index, style: { transform: x.interpolate(getSlideTransformStyle) }, singleelement: singleelement, className: "slider-spring-wrapper" }), tabs[index]))))));
}
exports.SliderCarousel = SliderCarousel;
